import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import { filter, get, includes } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';

import FormSelectField from 'embeds/components/ReduxForm/FormSelectField';
import FormTextField from 'embeds/components/ReduxForm/FormTextField';

const styles = (theme) => {
  const {
    palette: {
      error: { main },
    },
    spacing: { unit },
    custom: { fontSizes },
  } = theme;

  return {
    asterisk: {
      color: main,
    },
    label: {
      display: 'block',
      fontSize: fontSizes.bodyG,
      marginBottom: unit,
      marginLeft: unit / 2,
      transform: 'translate(0, 1.5px) scale(0.75) !important',
      transformOrigin: 'top left !important',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms !important',
      width: '133.33% !important',
    },
    root: {
      marginTop: unit,
    },
    type: {
      display: 'inline-block',
      float: 'left',
      position: 'relative',
      width: 131,
    },
    value: {
      display: 'inline-block',
      marginLeft: -1,
      position: 'relative',
      width: 'calc(100% - 130px)',
    },
  };
};

const TYPE_OPTIONS = [
  { id: 'sms', label: 'SMS' },
  { id: 'voice', label: 'Voice' },
  { id: 'email', label: 'E-Mail' },
  { id: 'whatsapp', label: 'WhatsApp' },
];

class UserContactField extends Component {
  constructor(props) {
    super(props);
    this.renderContact = this.renderContact.bind(this);
  }

  renderValue(item, index) {
    const { classes, disabled, fields } = this.props;
    const contact = fields.get(index).toJS();
    const contactType = get(contact, 'type', 'sms');
    const isTel = contactType === 'sms' || contactType === 'voice' || contactType === 'whatsapp';
    const type = isTel ? 'tel' : 'text';
    const placeholder = isTel ? '123-456-7890' : 'E-Mail';
    const mask = isTel ? 'phone' : '';
    /* isInvalid is a synonym for arhived = true */
    const isInvalid = contact.archived;
    const helperText = isInvalid ? 'Invalid contact' : '';

    return (
      <div className={classes.value}>
        <Field
          component={FormTextField}
          disabled={disabled}
          label=""
          mask={mask}
          name={`${item}.value`}
          placeholder={placeholder}
          type={type}
          error={isInvalid}
          helperText={helperText}
        />
      </div>
    );
  }

  renderType(item) {
    const { classes, disabled, excludedOptions } = this.props;
    let options = TYPE_OPTIONS;

    if (excludedOptions.length > 0) {
      options = filter(options, (option) => !includes(excludedOptions, option.id));
    }

    return (
      <div className={classes.type}>
        <Field
          component={FormSelectField}
          disabled={disabled}
          label=""
          name={`${item}.type`}
          options={options}
          searchable={false}
        />
      </div>
    );
  }

  renderContact(item, index) {
    return (
      <Grid item key={index} xs={12}>
        {this.renderType(item)}
        {this.renderValue(item, index)}
      </Grid>
    );
  }

  renderLabel() {
    const { classes, disabled, label, showRequiredMark } = this.props;

    if (!label) return;

    return (
      <InputLabel className={classes.label} disabled={disabled} htmlFor="patient">
        {label}
        {showRequiredMark && <span className={classes.asterisk}>*</span>}
      </InputLabel>
    );
  }

  render() {
    const { classes, fields } = this.props;

    return (
      <Grid container className={classes.root} spacing={8}>
        {this.renderLabel()}
        {fields.map(this.renderContact)}
      </Grid>
    );
  }
}

UserContactField.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  excludedOptions: PropTypes.array,
  fields: PropTypes.object,
  label: PropTypes.string,
  showRequiredMark: PropTypes.bool,
};

UserContactField.defaultProps = {
  disabled: false,
  excludedOptions: [],
  label: '',
  showRequiredMark: false,
};

export default withStyles(styles)(UserContactField);
